module.exports = __webpack_public_path__ + "img/icon-4.c5415483.png";